<template>
  <div>
    <fccModal
      idModal="modal-etapa"
      :titleModal="titleModal"
      size="xl"
      centered
      escondeFooter
      @change="changeModal"
    >
      <b-form @submit.prevent="salvar" autocomplete="off"
        ><div class="row mb-4">
          <div class="col"><fcc-input v-model="titulo" required>Título</fcc-input></div>
          <div class="col">
            <fcc-select :options="situacoesDetalhe" v-model="situacao" required
              >Situação</fcc-select
            >
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <fccDateInput type="datetime" v-model="dtInicio">Data de Início</fccDateInput>
          </div>
          <div class="col">
            <fccDateInput type="datetime" v-model="dtEntrega">Data de Entrega</fccDateInput>
          </div>
          <div class="col">
            <fcc-select :options="dificuldades" v-model="dificuldade" required
              >Dificuldade</fcc-select
            >
          </div>
          <div class="col">
            <fcc-input v-model="tempoHora" type="number" required
              >Tempo estimado (em horas)</fcc-input
            >
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <fcc-select :options="equipes" v-model="equipe" required>Equipe</fcc-select>
          </div>
          <div class="col">
            <fcc-select
              :disabled="responsaveis.length == 0"
              :options="responsaveis"
              v-model="responsavel"
              label-field="nomeresponsavel"
              required
              >Responsável</fcc-select
            >
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <label class="ml-j">Observação</label
            ><b-form-textarea rows="3" v-model="observacao"></b-form-textarea>
          </div>
        </div>
        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div></b-form
      >
    </fccModal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import store from '@/store'
import axios from 'axios'
import { acaoConstantes } from '../constants'

export default {
  props: {
    projectId: {
      type: String,
      default: ''
    },
    etapaTp: {
      type: Number,
      default: 0
    },
    acaoEtapa: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      titulo: '',
      situacao: null,
      dtInicio: '',
      dtEntrega: '',
      observacao: '',
      equipe: null,
      dificuldade: null,
      responsavel: null,
      tempoHora: '',
      titleModal: 'Adicionar Etapa'
    }
  },
  watch: {
    equipe(value) {
      if (value) {
        store.dispatch(
          'acompanhamentoDeProjetos/fetchResponsaveis',
          value.idequipe,
          this.dadosLoginSession.fccTokenHeaders
        )
      } else store.commit('acompanhamentoDeProjetos/SET_RESPONSAVEIS', [])
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', [
      'responsaveis',
      'dificuldades',
      'situacoesDetalhe',
      'projeto'
    ]),
    equipes() {
      return this.projeto?.equipes
    }
  },
  mounted() {
    store
      .dispatch('acompanhamentoDeProjetos/fetchAll', {
        config: this.dadosLoginSession.fccTokenHeaders,
        actions: ['Dificuldades', 'SituacoesDetalhe']
      })
      .catch(this.setErrorSystem)
  },
  methods: {
    changeModal() {
      if (this.acaoEtapa === acaoConstantes.ADICIONAR && !!this.etapaTp) {
        this.titleModal = 'Adicionar Etapa'
        this.reset()

        this.situacao = this.situacoesDetalhe.find(
          (situacao) => situacao.tpsituacaodetalhe === this.etapaTp
        )

        return
      }

      if (this.acaoEtapa === acaoConstantes.EDITAR) {
        this.titleModal = 'Editar Etapa'
        this.reset()
        this.titulo = this.item.detalhe
        this.situacao = this.situacoesDetalhe.find(
          (situacao) => situacao.tpsituacaodetalhe === this.item.tpsituacaodetalhe
        )
        this.dtInicio = this.item.dtinicio
        this.dtEntrega = this.item.dtentrega
        this.observacao = this.item.observacao
        this.dificuldade = this.dificuldades.find(
          (dificuldade) => dificuldade.tpdificuldade === this.item.tpdificuldade
        )
        this.tempoHora = this.item.tempohora
        this.equipe = this.equipes.find((eq) => eq.idequipe === this.item.equipe.idequipe)
        store
          .dispatch(
            'acompanhamentoDeProjetos/fetchResponsaveis',
            this.item.equipe.idequipe,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.responsavel = this.responsaveis.find(
              (resp) => resp.idresponsavel === this.item.responsavel.idresponsavel
            )
          })
          .catch(this.setErrorSystem)

        return
      }
    },
    reset() {
      this.titulo = ''
      this.situacao = null
      this.dtInicio = ''
      this.dtEntrega = ''
      this.observacao = ''
      this.equipe = null
      this.dificuldade = null
      this.responsavel = null
      this.tempoHora = ''
    },
    salvar() {
      this.callConfirm(
        this.acaoEtapa === acaoConstantes.EDITAR
          ? 'Deseja salvar as mudanças?'
          : 'Deseja adicionar uma nova etapa?',
        ''
      ).then((result) => {
        if (result.value) {
          if (this.acaoEtapa === acaoConstantes.ADICIONAR) {
            this.carregaTexto(this.codeMensagem('C01'))
            this.adicionar()
              .then(() => {
                this.carregaTexto()
                this.$root.$emit('bv::hide::modal', 'modal-etapa')
                this.callToast(this.mensagensUpdate.adicionado)
                this.$emit('salvo')
              })
              .catch(this.setErrorSystem)
          }

          if (this.acaoEtapa === acaoConstantes.EDITAR) {
            this.carregaTexto(this.codeMensagem('C01'))
            this.editar()
              .then(() => {
                this.carregaTexto()
                this.$root.$emit('bv::hide::modal', 'modal-etapa')
                this.callToast(this.mensagensUpdate.editado, 'success')
                this.$emit('salvo')
              })
              .catch(this.setErrorSystem)
          }
        }
      })
    },
    adicionar() {
      const payload = {
        idDetalhe: 0,
        idProjeto: this.projectId,
        detalhe: this.titulo,
        tpSituacaoDetalhe: this.situacao.tpsituacaodetalhe,
        dtInicio: this.dtInicio,
        dtEntrega: this.dtEntrega,
        observacao: this.observacao,
        idResponsavel: this.responsavel.idresponsavel,
        tpDificuldade: this.dificuldade.tpdificuldade,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        tempoHora: this.tempoHora
      }

      return new Promise((resolve) => {
        axios
          .post(
            store.state.baseUrlGestaoProjetos + 'ProjetoDetalhe/Adicionar',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
      })
    },
    editar() {
      const payload = {
        idDetalhe: this.item.iddetalhe,
        idProjeto: Number(this.projectId),
        detalhe: this.titulo,
        tpSituacaoDetalhe: this.situacao.tpsituacaodetalhe,
        dtInicio: this.dtInicio,
        dtEntrega: this.dtEntrega,
        observacao: this.observacao,
        idResponsavel: this.responsavel.idresponsavel,
        tpDificuldade: this.dificuldade.tpdificuldade,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        tempoHora: this.tempoHora
      }

      return new Promise((resolve) => {
        axios
          .put(
            store.state.baseUrlGestaoProjetos + 'ProjetoDetalhe/Alterar',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
      })
    }
  }
}
</script>
